// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./media/RuneScape-Bold-12.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./media/RuneScape-Plain-11.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./media/interface-border.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./media/interface-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "OSRS Bold";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
    font-family: "OSRS Small";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

:root {
    --app-vw: 100vw;
    --app-vh: 100dvh;
    --ios-safari-landscape-w: var(--app-vw);
    --ios-safari-landscape-h: var(--app-vh);
}

html,
body,
#root {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    font-family:
        -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
        "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
    background-color: black;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.max-height {
    height: 100%;
}

#root {
    overflow: hidden;
}

.page-loading {
    display: grid;
    width: 100%;
    height: 100%;
    place-items: center;
    color: white;
}

.App {
    position: fixed;
    inset: 0;
    width: var(--app-vw, 100vw);
    height: var(--app-vh, 100dvh);
    overflow: hidden;
    background: black;
}

.App.ios-safari-force-landscape {
    width: var(--ios-safari-landscape-w, var(--app-vw, 100vw));
    height: var(--ios-safari-landscape-h, var(--app-vh, 100dvh));
}

.App.ios-safari-force-landscape.ios-safari-force-landscape-rotated {
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    width: var(--ios-safari-landscape-w, var(--app-vh, 100dvh));
    height: var(--ios-safari-landscape-h, var(--app-vw, 100vw));
    transform: translate(-50%, -50%) rotate(90deg);
    transform-origin: center center;
}

canvas {
    outline: none;
    border: none;
    display: block;
}

.center-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.content-text {
    font-family: ui-monospace, SFMono-Regular, Menlo, "Roboto Mono", monospace;
    font-weight: bold;
    color: white;
    text-shadow: 1px 1px 0 black;
}

.flex {
    display: flex;
    flex: 1 1;
}

.align-right {
    justify-content: right;
}

.rs-border {
    border: 6px solid;
    border-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 6 / 6px / 0 repeat;
}

.rs-background {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,4CAAuC;AAC3C;AACA;IACI,yBAAyB;IACzB,4CAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,uCAAuC;AAC3C;;AAEA;;;IAGI,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;;IAEZ;;+DAE2D;IAC3D,mCAAmC;IACnC,kCAAkC;IAClC,gBAAgB;IAChB,uBAAuB;;IAEvB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACd,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB,EAAE;gFACyD;AAChF;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,0DAA0D;IAC1D,4DAA4D;AAChE;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,2DAA2D;IAC3D,2DAA2D;IAC3D,8CAA8C;IAC9C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0EAA0E;IAC1E,iBAAiB;IACjB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,wEAAkE;AACtE;;AAEA;IACI,yDAA+C;AACnD","sourcesContent":["@font-face {\n    font-family: \"OSRS Bold\";\n    src: url(./media/RuneScape-Bold-12.ttf);\n}\n@font-face {\n    font-family: \"OSRS Small\";\n    src: url(./media/RuneScape-Plain-11.ttf);\n}\n\n:root {\n    --app-vw: 100vw;\n    --app-vh: 100dvh;\n    --ios-safari-landscape-w: var(--app-vw);\n    --ios-safari-landscape-h: var(--app-vh);\n}\n\nhtml,\nbody,\n#root {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n\n    font-family:\n        -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\",\n        \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow: hidden;\n    background-color: black;\n\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.max-height {\n    height: 100%;\n}\n\n#root {\n    overflow: hidden;\n}\n\n.page-loading {\n    display: grid;\n    width: 100%;\n    height: 100%;\n    place-items: center;\n    color: white;\n}\n\n.App {\n    position: fixed;\n    inset: 0;\n    width: var(--app-vw, 100vw);\n    height: var(--app-vh, 100dvh);\n    overflow: hidden;\n    background: black;\n}\n\n.App.ios-safari-force-landscape {\n    width: var(--ios-safari-landscape-w, var(--app-vw, 100vw));\n    height: var(--ios-safari-landscape-h, var(--app-vh, 100dvh));\n}\n\n.App.ios-safari-force-landscape.ios-safari-force-landscape-rotated {\n    top: 50%;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    width: var(--ios-safari-landscape-w, var(--app-vh, 100dvh));\n    height: var(--ios-safari-landscape-h, var(--app-vw, 100vw));\n    transform: translate(-50%, -50%) rotate(90deg);\n    transform-origin: center center;\n}\n\ncanvas {\n    outline: none;\n    border: none;\n    display: block;\n}\n\n.center-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.content-text {\n    font-family: ui-monospace, SFMono-Regular, Menlo, \"Roboto Mono\", monospace;\n    font-weight: bold;\n    color: white;\n    text-shadow: 1px 1px 0 black;\n}\n\n.flex {\n    display: flex;\n    flex: 1;\n}\n\n.align-right {\n    justify-content: right;\n}\n\n.rs-border {\n    border: 6px solid;\n    border-image: url(./media/interface-border.png) 6 / 6px / 0 repeat;\n}\n\n.rs-background {\n    background-image: url(./media/interface-bg.png);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
